import type { PromptDto } from "@/lib/queries";
import type { PromptUsageRowDto } from "@/features/prompts/api/prompts.api";

export interface PromptKpis {
  /** Distinct call sites covered by the listed prompts. */
  callSites: number;
  /** Prompts scoped to a tenant rather than serving as the global fallback. */
  overrides: number;
  total: number;
  inactive: number;
  /** Prompts whose latest version pins no model, so the service default applies. */
  serviceDefault: number;
  /** Sum of priced costMicros across visible prompts in the usage window. */
  usageCostMicros: number;
  usageUnpricedTokens: number;
}

export function summarizePrompts(
  prompts: PromptDto[],
  usageByPromptId: ReadonlyMap<string, PromptUsageRowDto> = new Map(),
): PromptKpis {
  const callSites = new Set<string>();
  let overrides = 0;
  let inactive = 0;
  let serviceDefault = 0;
  let usageCostMicros = 0;
  let usageUnpricedTokens = 0;

  for (const prompt of prompts) {
    callSites.add(prompt.usedIn);
    if (prompt.tenantId) overrides += 1;
    if (prompt.status !== "ACTIVE") inactive += 1;
    if (!prompt.latestVersion?.model) serviceDefault += 1;
    const usage = usageByPromptId.get(prompt.id);
    if (usage) {
      usageCostMicros += usage.costMicros;
      usageUnpricedTokens += usage.unpricedTokens;
    }
  }

  return {
    callSites: callSites.size,
    overrides,
    total: prompts.length,
    inactive,
    serviceDefault,
    usageCostMicros,
    usageUnpricedTokens,
  };
}
